
function HomeSection2() {
    return (
        <section class="main-container"> 
          <h1> Testing 2 </h1>
       </section>
    )
}

export default HomeSection2;